import PropTypes from 'prop-types'
import React from 'react'
import { isEmpty } from 'lodash'
import cx from 'classnames'

import classes from './List.scss'

import ListItem from './Item'
import ListItemColumn from './Item/Column'

export const List = (props) => {
  const columnOptions = []
  const rowOptions = []
  if (props.columnOptions.length) {
    props.columnOptions.forEach((column, index) => {
      if (Array.isArray(column)) {
        columnOptions[index] = {}
        column.forEach(option => {
          columnOptions[index][option] = true
        })
      } else if (column) {
        columnOptions[index] = { [column]: true }
      }
    })
  }

  if (props.rowOptions.length) {
    props.rowOptions.forEach((row, index) => {
      if (Array.isArray(row)) {
        rowOptions[index] = {}
        row.forEach(option => {
          rowOptions[index][option] = true
        })
      } else if (row) {
        rowOptions[index] = { [row]: true }
      }
    })
  }

  const className = cx({
    [classes['list']]: classes['list'],
    [classes['list--partial']]: props.partial
  })

  return (
    <table className={className}>
      {!isEmpty(props.headers) &&
        <thead className={classes['list__head']}>
          <tr>
            {props.headers.map((name, index) => {
              const options = columnOptions && columnOptions[index]

              return (
                <ListItemColumn header key={index} {...props} {...options}>{name}</ListItemColumn>
              )
            })}
          </tr>
        </thead>
      }

      <tbody className={classes['list__items']}>
        {!isEmpty(props.data) && props.data
          .filter(o => o.data && Array.isArray(o.data) && o.data.length)
          .map((obj, index) =>
            <ListItem
              data={obj.data} // data = [ { link: '/path', data: [ '', ...] }, ... ]
              options={columnOptions}
              {...(rowOptions && rowOptions[index])}
              link={obj.link}
              key={index}
            />
        )}
      </tbody>
    </table>
  )
}

List.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.string),
  columnOptions: PropTypes.array,
  rowOptions: PropTypes.array,
  data: PropTypes.arrayOf(
    PropTypes.object
  ).isRequired,
  partial: PropTypes.bool
}

List.defaultProps = {
  columnOptions: [],
  rowOptions: [],
  partial: false
}

export default List



// WEBPACK FOOTER //
// ./src/components/List/List.js